module.exports = __webpack_public_path__ + "static/media/sillyimages.50c10d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/sillyimages.jpg
// module id = 242
// module chunks = 0